export const uploadFile = files =>
  Promise.all(
    files.map(
      file =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = () => {
            const { lastModified, name, size, type } = file;
            const data = reader.result.replace(/^data:(.*;base64,)?/, '');
            const document = {
              lastModified,
              name,
              size,
              data,
              type,
            };

            resolve(document);
          };
          reader.onerror = error => {
            reject(error);
          };
        }),
    ),
  );
